import { Link } from "react-router-dom";

const HINTS = {
  platform: {
    role: "Platform Admin",
    email: "platform.admin@yug360.demo",
    path: "/admin/platform",
  },
  tenant: {
    role: "Tenant Admin",
    email: "tenant.admin@yug360.demo",
    path: "/admin/tenant",
  },
};

export default function AdminConsoleGate({ user, kind = "platform" }) {
  const hint = HINTS[kind] || HINTS.platform;
  return (
    <div className="login-page" data-testid={`admin-console-gate-${kind}`}>
      <div className="login-card wide">
        <p className="kicker">ADMIN CONSOLE · ACCESS</p>
        <h1>{hint.role} sign-in required</h1>
        <p className="intro-copy">
          You are signed in as <strong>{user?.name || user?.email}</strong> ({user?.role}).
          The {hint.role} control plane is a separate console and does not share the product workspace session.
        </p>
        <p className="admin-note">
          Sign out, then sign in with <code>{hint.email}</code> and open <code>{hint.path}</code>.
        </p>
        <div className="login-actions">
          <Link className="secondary-button" to="/">Back to workspace</Link>
          <Link className="primary-button" to={`/login?email=${encodeURIComponent(hint.email)}`}>
            Switch to {hint.role}
          </Link>
          <Link className="secondary-button" to="/logout">Sign out</Link>
        </div>
      </div>
    </div>
  );
}
